// src/pages/UnauthorizedPage.tsx
// 403 page — shown when a user lacks the required permission/role with a premium, professional UI.
import { Link, useNavigate } from 'react-router-dom'
import { ArrowLeft, Home } from 'lucide-react'

export default function UnauthorizedPage() {
  const navigate = useNavigate()

  return (
    <div className="dualon min-h-screen relative flex items-center justify-center bg-[var(--bg-0)] px-6 overflow-hidden select-none">
      {/* Decorative Glow Elements */}
      <div className="absolute -top-[10%] -left-[10%] w-[350px] h-[350px] rounded-full bg-[var(--mint-500)]/10 blur-[120px] pointer-events-none" />
      <div className="absolute -bottom-[15%] -right-[5%] w-[450px] h-[450px] rounded-full bg-[var(--violet-500)]/10 blur-[150px] pointer-events-none" />
      <div className="absolute top-[40%] right-[10%] w-[250px] h-[250px] rounded-full bg-[var(--sky)]/10 blur-[100px] pointer-events-none" />

      {/* Main 403 Card Container */}
      <div className="relative z-10 max-w-lg w-full p-8 md:p-12 text-center flex flex-col items-center">
        {/* Big 403 Header with Gradients */}
        <h1 className="t-display text-9xl font-black tracking-tighter leading-none mb-4 select-none animate-pulse-slow" style={{ fontFamily: 'var(--fs-display)' }}>
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[var(--mint-500)] via-[var(--sky)] to-[var(--violet-500)]">
            403
          </span>
        </h1>

        <h2 className="text-xl md:text-2xl font-extrabold text-[var(--txt)] mb-3 tracking-tight">
          Unauthorized Access
        </h2>
        <p className="text-sm font-semibold text-[var(--txt-3)] leading-relaxed mb-8 max-w-xs">
          You don&apos;t have access to this page. Please contact your administrator if you think this is a mistake.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 w-full justify-center">
          <button
            onClick={() => navigate(-1)}
            className="tap flex-1 px-5 py-3 rounded-xl border border-[var(--glass-brd)] bg-[var(--glass)] hover:bg-[var(--glass-2)] text-xs font-bold text-[var(--txt-2)] hover:text-[var(--txt)] flex items-center justify-center gap-1.5 transition-all cursor-pointer shadow-sm"
          >
            <ArrowLeft size={14} />
            <span>Go Back</span>
          </button>
          <Link
            to="/dashboard"
            className="tap flex-[1.5] px-5 py-3 rounded-xl bg-gradient-to-r from-[var(--mint-400)] to-[var(--mint-600)] hover:opacity-95 text-xs font-extrabold text-[#06231a] flex items-center justify-center gap-1.5 transition-all cursor-pointer shadow-md"
          >
            <Home size={14} />
            <span>Return to Dashboard</span>
          </Link>
        </div>
      </div>
    </div>
  )
}
